import { Component, Input } from '@angular/core'
import { EnvService } from '@envs/env-service'
import { NavigationService } from '@app/core/service/navigation.service'

@Component({
  selector: 'app-duplicate-scope-template',
  templateUrl: './duplicate-scope-template.component.html',
  styleUrls: ['./duplicate-scope-template.component.scss'],
})
export class DuplicateScopeTemplateComponent {
  @Input() id!: number
  @Input() templateId!: number

  constructor(
    private envService: EnvService,
    private navigationService: NavigationService
  ) {
    this.navigationService.subscribeToNavigationMessages()
  }

  public get baseJsUrl(): string {
    return `${this.envService.baseJsUrl}/duplicate-template/${this.id}`
  }
}
